const url = 'https://api.profaprizattera.com.br/api';
//const url = 'http://localhost:8881/api';

export default url;